import React from 'react'
import GenericPullAndPushToolView from '../GenericPullAndPushToolView'
import LaceworkConfigListing from './LaceworkConfigListing'
import LaceworkCredentialsForm from './LaceworkCredentialsForm'

export default function LaceworkPullAndPushView(props) {
    return (
        <GenericPullAndPushToolView 
            {...props}
            PullCredentialForm={LaceworkCredentialsForm}
            PullConfigListingView={LaceworkConfigListing}
        />
    )
}